

module.directive('programSelect', function($http, ApiUrl) {
    return {
        restrict: 'E',
        require: 'ngModel',
        scope: {},
        templateUrl: 'util/forms/programSelect',
        link: function(scope, element, attrs, ngModel) {
            var type = attrs.type || 'autocomplete',
                base_params = {}, name;

            scope.search = "";

            scope.programs = [];
            scope.data = {};

            for (name in attrs) {
                if (name.substring(0, 6) === 'filter') {
                    attrs.$observe(name, (function(name, val) {
                        base_params[name.substring(6).toLowerCase()] = val;
                    }).bind(this, name))
                }
            }

            function make_params(search) {
                var params = angular.copy(base_params);
                params.search = search;
                return {params: params};
            }

            scope.refreshPrograms = function(search) {
                $http.get(ApiUrl('program', type), make_params(search))
                    .then(function(response) {
                        scope.programs = response.data.items;
                    })
            };

            ngModel.$render = function() {
                scope.data.value = ngModel.$viewValue;
            };

            scope.change = function(value) {
                ngModel.$setViewValue(parseInt(value));
                ngModel.$render();
            };

        },
    };
});
